import { createSlice } from "@reduxjs/toolkit";
import {
  setSuccess,
  hideSuccess
} from './actions';

export const initialState = {
  message: '',
  open: false
};

const  slice = createSlice({
  name: 'success',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(setSuccess, (state, action) => {
        const message = action.payload;

        state.message = message;
        state.open = true;
      })
      .addCase(hideSuccess, state => {
        state.message = initialState.message;
        state.open = initialState.open;
      })
  }
})

export default slice.reducer;